import React from 'react';

import { IconProps } from 'reactComponents/icons/utilities/iconUtils';

export default function IconSupport({
    width = 16,
    height = 16,
    className = '',
}: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path d="M1.005,6.227 C1.149,2.766 4.004,0 7.5,0 L8.5,0 C11.996,0 14.851,2.766 14.994,6.227 C15.612,6.543 16,7.173 16,8 L16,11 C16,12.1 15.288,12.894 14.22,12.99 C14.197,14.666 12.708,16 11,16 L10,16 L8,16 C7.448,16 7,15.552 7,15 C7,14.448 7.448,14 8,14 L10.931,14 C11.214,14 11.486,13.887 11.687,13.687 C11.877,13.497 11.988,13.242 11.999,12.975 C11.429,12.858 11,12.354 11,11.75 L11,7.25 C11,6.56 11.56,6 12.25,6 L12.973,6 C12.724,3.647 10.73,1.811 8.311,1.811 L7.689,1.811 C5.27,1.811 3.276,3.647 3.026,6 L3.75,6 C4.44,6 5,6.56 5,7.25 L5,11.75 C5,12.44 4.44,13 3.75,13 L2,13 C0.812,13 0,12.174 0,11 L0,8 C0,7.173 0.388,6.543 1.005,6.227 Z" />
        </svg>
    );
}
